// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import urls from '@src/@core/auth/jwt/urls'
// ** Axios Imports
import axios from 'axios'
import { errorToast, sucessToast } from '../../../components/messageToast/messageToast'

const qs = require('qs')

const api = axios.create({
  baseURL: urls.url,
  headers: {
    Authorization: `Bearer ${localStorage.getItem('token')}`,
    'Content-Type': 'application/json'
  }
})

export const getAllData = createAsyncThunk('appCustomers/getAllData', async (params) => {
  const instanceGet = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" }
  })
  const response = await instanceGet.get(`/customers/customers/`, { params: { p: params.page, search: params.query, page_size: params.page_size } })
  return response
})

export const getAllCategories = createAsyncThunk('appCustomers/getAllCategories', async () => {
  const instanceGet = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" }
  })
  const response = await instanceGet.get(`/customers/categories/get_allDetail/`)
  return response
})

export const getSubCategories = createAsyncThunk('appCustomers/getCategories', async id => {
  const instance = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" }
  })

  const response = await instance.get(`/customers/getSubcategoriesByClient/${id}`)
  return response.data
})

export const getCustomer = createAsyncThunk('appCustomers/getCustomer', async id => {
  const instance = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" }
  })

  const response = await instance.get(`/customers/customers/${id}/`)
  return response.data
})

export const getContact = createAsyncThunk('appCustomers/getContact', async id => {
  const instance = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" }
  })
  const response = await instance.get(`/customers/contacts/${id}/`)
  return response.data
})

export const addContact = createAsyncThunk('appCustomers/addContact', (params, { dispatch }) => {
  const instance = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" }
  })
  instance.post(`/customers/contacts/`, params.contact)
    .then(async resp => {
      await dispatch(getCustomer(params.idCustomer))
      sucessToast("Contacto se añadio correctamente")
      return resp.data
    })
    .catch(() => {
      errorToast("Contacto no se añadio correctamente")
    })

})

export const cleanContacts = createAsyncThunk('appCustomers/cleanContacts', () => {
  return "clean"
})

export const updateContact = createAsyncThunk('appCustomers/updateContact', (params, { dispatch }) => {
  const instance2 = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/x-www-form-urlencoded" }
  })
  instance2.put(`/customers/contacts/${params.contact.id}/`, qs.stringify(params.contact))
    .then(async resp => {
      await dispatch(getCustomer(params.idCustomer))
      sucessToast("Contacto se modifico correctamente")
      return resp.data
    })
    .catch(() => {
      errorToast("Contacto no se modifico correctamente")
    })

})


export const deleteContact = createAsyncThunk('appCustomers/deleteContact', (params, { dispatch }) => {
  const instance = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" }
  })
  instance.delete(`/customers/contacts/${params.idContact}/`)
    .then(async resp => {
      await dispatch(getCustomer(params.idCustomer))
      sucessToast("Contacto se elimino correctamente")
      return resp.data
    })
    .catch(() => {
      errorToast("Contacto no se elimino correctamente")
    })

})

export const addCustomer = createAsyncThunk('appCustomers/addCustomer', async (params, { dispatch }) => {
  const instance = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/json" }
  })

  instance.post('/customers/customers/', params.customer)
    .then(async resp => {
      await dispatch(getAllData({ page: 1, query: "" }))
      sucessToast("Cliente añadido correctamente")
      return resp.data
    })
    .catch((err) => {
      if (err?.response?.data?.error) {
        errorToast(err.response.data.msg)
      } else {
        errorToast("Cliente no fue creado correctamente")
      }
    })

})

export const updateCustomer = createAsyncThunk('appCustomers/updateCustomer', (params, { dispatch }) => {
  const instance2 = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/x-www-form-urlencoded" }
  })
  instance2.put(`/customers/customers/${params.customer.id}/`, qs.stringify(params.customer))
    .then(async resp => {
      await dispatch(getCustomer(params.customer.id))
      await dispatch(getSubCategories(params.customer.id))
      sucessToast("Cliente se modifico correctamente")
      return resp.data
    })
    .catch((err) => {
      errorToast(err?.response?.data?.msg ?? "Cliente no se modifico correctamente")
    })
})


export const updateCustomerWithoutToast = createAsyncThunk('appCustomers/updateCustomerWithoutToast', (params, { dispatch }) => {
  const instance2 = axios.create({
    baseURL: urls.url,
    timeout: 5000,
    headers: { Authorization: "Bearer " + localStorage.getItem("token"), "Content-Type": "application/x-www-form-urlencoded" }
  })
  instance2.put(`/customers/customers/${params.customer.id}/`, qs.stringify(params.customer))
    .then(async resp => {
      await dispatch(getAllData(params.getData))
      return resp.data
    })
    .catch(() => {
      errorToast("Cliente no se modifico correctamente")
    })
})

export const deleteUser = createAsyncThunk('appCustomers/deleteUser', async (id, { dispatch }) => {
  await axios.delete(`/customers/customers/${id}/`)
  await dispatch(getAllData({ page: 1, query: "" }))
  return id
})

export const setIsFetchingResults = createAsyncThunk('appCustomers/setIsFetchingResults', () => {
  return "fetching"
})

export const updateCustomerCmInfo = createAsyncThunk(
  'appCustomers/updateCustomerCmInfo',
  async ({ id, data }, { dispatch }) => {
    const instance = axios.create({
      baseURL: urls.url,
      // timeout: 5000,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    })

    try {
      const response = await instance.patch(`/customers/customers/${id}/update_cash_management/`, { data })
      await dispatch(getCustomer(id))
      await dispatch(getSubCategories(id))
      sucessToast('Cliente actualizado correctamente')
      return response.data
    } catch (err) {
      errorToast(err?.response?.data?.msg || 'No se pudo actualizar el cliente')
      throw err
    }
  }
)

export const getBankCodesByBank = createAsyncThunk(
  'appCustomers/getBankCodesByBank',
  async (bankId, { rejectWithValue }) => {
    try {
      const instance = axios.create({
        baseURL: urls.url,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      })
      const response = await instance.get(`/customers/bankcodes/?bank=${bankId}`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error loading bank codes')
    }
  }
)

export const createCustomerCreditCardInfo = createAsyncThunk(
  'customerCreditCardInfo/create',
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const instance = axios.create({
        baseURL: urls.url,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      const response = await instance.post('/customers/credit_card_info/', data)
      await dispatch(getCustomer(data.customer_id))
      let msg = 'Tarjeta actualizada correctamente. '
      if (response.data.is_active) msg += 'Se desactivo Débito Automático.'
      console.log(response)
      sucessToast(msg || 'Tarjeta registrada correctamente')
      return response.data
    } catch (error) {
      errorToast(error.response?.data?.error || 'Error al registrar tarjeta')
      return rejectWithValue(error.response?.data)
    }
  }
)

export const updateCustomerCreditCardInfo = createAsyncThunk(
  'customerCreditCardInfo/update',
  async ({ id, data }, { dispatch, rejectWithValue }) => {
    try {
      const instance = axios.create({
        baseURL: urls.url,
        // timeout: 5000,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      })
      const response = await instance.patch(`/customers/credit_card_info/${id}/`, data)
      await dispatch(getCustomer(data.customer_id))
      let msg = 'Tarjeta actualizada correctamente. '
      if (response.data.is_active) msg += 'Se desactivo Débito Automático.'
      sucessToast(msg || 'Tarjeta actualizada correctamente')
      return response.data
    } catch (error) {
      console.log(error)
      errorToast(error.response?.data?.error || 'Error al actualizar tarjeta')
      return rejectWithValue(error.response?.data)
    }
  }
)


export const deleteCustomerCreditCard = createAsyncThunk(
  'creditCard/deleteCustomerCreditCard',
  async (data, { dispatch }) => {
    console.log(data)
    const response = await api.delete(`/customers/credit_card_info/${data.id}/`)
    sucessToast('Tarjeta eliminada correctamente')
    await dispatch(getCustomer(data.customer_id))
    return response.data
  }
)

export const createUpdateBankCmInfo = createAsyncThunk(
  'appCustomers/createUpdateBankCmInfo',
  async ({ id, data }, { dispatch }) => {
    const instance = axios.create({
      baseURL: urls.url,
      // timeout: 5000,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    })

    try {
      const response = await instance.post(`/customers/customers/${id}/create_or_update_bank_customer/`, data)
      await dispatch(getCustomer(id))
      await dispatch(getSubCategories(id))
      sucessToast('Cliente actualizado correctamente')
      return response.data
    } catch (err) {
      errorToast(err?.response?.data?.msg || 'No se pudo actualizar el cliente')
      throw err
    }
  }
)

export const deleteBankCmInfo = createAsyncThunk(
  'appCustomers/deleteBankCmInfo',
  async ({ id, data }, { dispatch }) => {
    const instance = axios.create({
      baseURL: urls.url,
      // timeout: 5000,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    })
    try {
      const response = await instance.post(`/customers/customers/${id}/delete_bank_customer/`, { data })
      await dispatch(getCustomer(id))
      await dispatch(getSubCategories(id))
      sucessToast('Información bancaria eliminada correctamente')
      return response.data
    } catch (err) {
      errorToast(err?.response?.data?.msg || 'No se pudo eliminar la información bancaria')
      throw err
    }
  }
)

export const setIsActiveCustomer = createAsyncThunk(
  'appCustomers/setIsActiveCustomer',
  async ({ id, is_active_cm }, { dispatch }) => {
    const instance = axios.create({
      baseURL: urls.url,
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`,
        'Content-Type': 'application/json'
      }
    })
    try {
      const response = await instance.patch(`/customers/customers/${id}/set_is_active/`, { is_active_cm })
      await dispatch(getCustomer(id))
      await dispatch(getSubCategories(id))
      sucessToast(response.data.msg || `Débito ${is_active_cm ? 'activado' : 'desactivado'} correctamente`)
      return response.data
    } catch (err) {
      errorToast(err?.response?.data?.msg || 'No se pudo actualizar el estado del cliente')
      throw err
    }
  }
)

export const getCities = createAsyncThunk(
  'appCustomers/getCities',
  async () => {
    try {
      const instance = axios.create({
        baseURL: urls.url,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      })
      const response = await instance.get('/customers/cities/')
      return response.data
    } catch (error) {
      errorToast(err?.response?.data?.msg || 'Error al cargar ciudades')
      throw err
    }
  }
)

export const getCardsDatafast = createAsyncThunk(
  'appCustomers/getCardsDatafast',
  async (customerId, { rejectWithValue }) => {
    try {
      const instance = axios.create({
        baseURL: urls.url,
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`,
          'Content-Type': 'application/json'
        }
      })
      const response = await instance.get(`/customers/customers/${customerId}/get_cards_datafast/`)
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Error loading cards')
    }
  }
)


export const appCustomersSlice = createSlice({
  name: 'appCustomers',
  initialState: {
    allData: [],
    allCategories: [],
    selectedSubcategories: [],
    bankCodes: [],
    loadingBankCodes: false,
    errorBankCodes: null,
    total: 1,
    selectedCustomer: null,
    selectedContact: null,
    isFetching: false,
    cardsDatafast: []
  },
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(setIsFetchingResults.fulfilled, (state) => {
        state.isFetching = true
      })
      .addCase(getAllData.fulfilled, (state, action) => {
        state.allData = action.payload.data.results
        state.total = action.payload.data.count
        state.isFetching = false
      })

      .addCase(getAllCategories.fulfilled, (state, action) => {
        state.allCategories = action.payload.data
        state.isFetching = false
      })

      .addCase(getSubCategories.fulfilled, (state, action) => {
        state.selectedSubcategories = action.payload
        state.isFetching = false
      })

      .addCase(getCustomer.fulfilled, (state, action) => {
        state.selectedCustomer = action.payload
      })

      .addCase(getContact.fulfilled, (state, action) => {
        state.selectedContact = action.payload
      })

      .addCase(cleanContacts.fulfilled, (state) => {
        state.allData = []
        state.total = 1
      })
      .addCase(getBankCodesByBank.pending, state => {
        state.loadingBankCodes = true
        state.errorBankCodes = null
      })
      .addCase(getBankCodesByBank.fulfilled, (state, action) => {
        state.loadingBankCodes = false
        state.bankCodes = action.payload
      })
      .addCase(getBankCodesByBank.rejected, (state, action) => {
        state.loadingBankCodes = false
        state.errorBankCodes = action.payload
      })
      .addCase(getCardsDatafast.fulfilled, (state, action) => {
        state.cardsDatafast = action.payload.cards
      })
  }
})

export default appCustomersSlice.reducer
